import { Text, Tooltip, useMantineTheme } from "@mantine/core";
import { ReactElement } from "react";
import InlineFlex from "@common/components/thirdParty/mantine/InlineFlex";
import IconInfoOutline from "@common/components/icons/IconInfoOutline";
import { IFormInputLabelProps } from "./types";

export default function FormInputLabel({
  text,
  tooltipText,
}: IFormInputLabelProps): ReactElement {
  const theme = useMantineTheme();

  const label = (
    <InlineFlex
      align="baseline"
      direction="row"
      justify="flex-start"
      gap={theme.spacing.xs / 2}
      mb="xs"
    >
      <Text c="gray.4" fw={700} fz="sm">
        {text}
      </Text>
      {tooltipText && (
        <IconInfoOutline color={theme.colors.gray[8]} size={12} />
      )}
    </InlineFlex>
  );

  return tooltipText ? (
    <Tooltip
      arrowSize={theme.spacing.xs}
      label={<Text fz="xs">{tooltipText}</Text>}
      withArrow
      withinPortal
    >
      {label}
    </Tooltip>
  ) : (
    label
  );
}
